import { makeStyles } from "tss-react/mui";
const useAutoAdjustedComplexTooltipClasses = makeStyles()(() => ({
  autoAdjustedComplexTooltipHiddenElement: {
    visibility: "hidden",
    position: "absolute",
    overflow: "visible"
  },
  autoAdjustedComplexTooltipElement: {
    width: "fit-content",
    display: "flex",
    overflow: "hidden"
  }
}));
export {
  useAutoAdjustedComplexTooltipClasses
};
//# sourceMappingURL=AutoAdjustedComplexTooltip.styles.js.map
